import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 12 12"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#6E6E7D",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": ".845",
      d: "M8.136 3.322h-.361v-.361z",
      style: {"stroke":"color(display-p3 .4296 .4296 .4915)","stroke-opacity":"1"}
    }, null, -1),
    _createElementVNode("path", {
      fill: "#A7A7B1",
      d: "M6.053 1.495a.45.45 0 0 1 .394.395l.004.052v1.803l.002.068a.9.9 0 0 0 .828.83l.072.003h1.801l.053.003a.454.454 0 0 1 .396.396l.002.053v.905L9.562 6c-.302 0-.58.103-.801.274v-.783H7.319l-.07-.004-.034-.002a1.75 1.75 0 0 1-1.607-1.645l-.002-.068V2.337H3.713a.51.51 0 0 0-.475.507v6.285l.001.054a.51.51 0 0 0 .506.477h3.315c.24.285.6.466 1.002.466h.187v.188q0 .097.015.19H3.747l-.129-.005a1.35 1.35 0 0 1-.701-.278l-.098-.084a1.35 1.35 0 0 1-.423-.905l-.001-.079v-6.31c0-.3.1-.592.284-.828l.084-.098c.236-.25.56-.403.904-.423l.08-.002H6z",
      style: {"fill":"color(display-p3 .6543 .6543 .6951)","fill-opacity":"1"}
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#fff",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M9.563 7.313v3m-1.5-1.5h3",
      style: {"stroke":"#fff","stroke-opacity":"1"}
    }, null, -1)
  ])))
}
export default { render: render }